module.exports = "query TransportsContractsQuery{transportsContracts{id type name key label cuttoff departements{id departement{id rowId codeDept}cuttoff}}}"